import {
    ApprovalStatus,
    CertificateStatus,
    CertificateType,
    ExamineeSource,
    FundingSource,
    Gender,
    GraduationStatus,
    HighestDegree,
    HighestEducation,
    HouseholdType,
    IdentityType,
    KlassStatus,
    MaritalType,
    OccupationLevel,
    OpenKlassStatus,
    PaymentStatus,
    PersonnelType,
    PoliticalAffiliationType,
    PublishStatus,
    RegistrationStatus,
    RegistrationType,
    Roles,
    StorageBusinessType,
    TrainType,
    YesOrNO
} from "@/scripts/enums";

export class Constants {
    QUERY_ALL_SIZE = 10000;
    THROTTLE_WAIT = 1000;
    COUNTDOWN_MAX = 60;
    COUNTDOWN_LOCAL_STORAGE_KEY = "LOCAL_STORAGE_COUNTDOWN";

    UPLOAD_URL = "/api/storage/upload";

    DATETIME_FMT = "YYYY-MM-DD HH:mm";
    DATE_FMT = "YYYY-MM-DD";
    DURATION_FMT = "HH:mm:ss";

    YES: YesOrNO = YesOrNO.YES;
    NO: YesOrNO = YesOrNO.NO;

    GENDER: Gender[] = [Gender.MALE, Gender.FEMALE];

    STORAGE_BUSINESS_TYPE_USER = StorageBusinessType.USER;
    STORAGE_BUSINESS_TYPE_ENROLLMENT = StorageBusinessType.ENROLLMENT;
    STORAGE_BUSINESS_TYPE_ENROLLMENT_USER = StorageBusinessType.ENROLLMENT_USER;

    CUSTOM_ICON_PREFIX = "icomoon";

    OCCUPATION_LEVELS: OccupationLevel[] = [
        OccupationLevel.LEVEL_1,
        OccupationLevel.LEVEL_2,
        OccupationLevel.LEVEL_3,
        OccupationLevel.LEVEL_4,
        OccupationLevel.LEVEL_5,
        OccupationLevel.NONE
    ];

    HOUSEHOLD_TYPES: HouseholdType[] = [HouseholdType.RURAL, HouseholdType.TOWN];

    IDENTITY_TYPES: IdentityType[] = [
        IdentityType.ID_CARD,
        IdentityType.OFFICERS,
        IdentityType.HK_SAR_PASSPORT,
        IdentityType.MACAO_SAR_PASSPORT,
        IdentityType.TAIWAN_TO_MAINLAND_PASS_CHECK,
        IdentityType.PASSPORT,
        IdentityType.OVERSEAS_PERMANENT_RESIDENCE_PERMIT,
        IdentityType.CRIMINAL_ID
    ];

    POLITICAL_AFFILIATION_TYPES: PoliticalAffiliationType[] = [
        PoliticalAffiliationType.PARTY_MEMBER,
        PoliticalAffiliationType.LEAGUE_MEMBER,
        PoliticalAffiliationType.MASS,
        PoliticalAffiliationType.OTHER
    ];

    CERTIFICATE_TYPES: CertificateType[] = [CertificateType.FORENSICS, CertificateType.NON_FORENSICS];

    PUBLISH_STATUS: PublishStatus[] = [PublishStatus.PUBLISHED, PublishStatus.UNPUBLISHED, PublishStatus.CANCELLED];

    REGISTRATION_STATUS: RegistrationStatus[] = [
        RegistrationStatus.NOT_STARTED,
        RegistrationStatus.PROCESSING,
        RegistrationStatus.ENDED
    ];

    KLASS_STATUS: KlassStatus[] = [KlassStatus.NOT_STARTED, KlassStatus.IN_PROGRESS, KlassStatus.ENDED];

    OPEN_KLASS_STATUS: OpenKlassStatus[] = [OpenKlassStatus.UN_OPEN, OpenKlassStatus.OPENED];

    APPROVAL_STATUS: ApprovalStatus[] = [ApprovalStatus.PENDING, ApprovalStatus.APPROVED, ApprovalStatus.REJECTED];

    PAYMENT_STATUS: PaymentStatus[] = [
        PaymentStatus.PAY_PENDING,
        PaymentStatus.PAY_SUCCESS,
        PaymentStatus.REFUND_PENDING,
        PaymentStatus.REFUND_SUCCESS
    ];

    TRAIN_TYPES: TrainType[] = [TrainType.THEORY, TrainType.PRACTICE, TrainType.ALL, TrainType.OTHER];

    GRADUATION_STATUS: GraduationStatus[] = [
        GraduationStatus.UN_GRADUATED,
        GraduationStatus.GRADUATED,
        GraduationStatus.DELAY_GRADUATED,
        GraduationStatus.NON_COMPLETION
    ];

    CERTIFICATE_STATUS: CertificateStatus[] = [CertificateStatus.ISSUED, CertificateStatus.UNISSUED];

    EXAMINEE_SOURCE: ExamineeSource[] = [
        ExamineeSource.SOCIETY,
        ExamineeSource.ENTERPRISE,
        ExamineeSource.COLLEGE,
        ExamineeSource.ARMY,
        ExamineeSource.GRADUATE,
        ExamineeSource.PRISONER,
        ExamineeSource.OFFICE,
        ExamineeSource.STATE_INSTITUTION,
        ExamineeSource.DISABLED,
        ExamineeSource.NEW_JOB,
        ExamineeSource.CBT,
        ExamineeSource.TECHNICIAN,
        ExamineeSource.SPECIAL_WORK,
        ExamineeSource.EVALUATION_PILOT,
        ExamineeSource.LOCAL_FARMER,
        ExamineeSource.UNEMPLOYED
    ];

    PERSONNEL_TYPE: PersonnelType[] = [
        PersonnelType.STAFF,
        PersonnelType.STUDENT,
        PersonnelType.UNEMPLOYEE,
        PersonnelType.RURAL_LABOR
    ];

    HIGHEST_EDUCATION: HighestEducation[] = [
        HighestEducation.NONE,
        HighestEducation.PRIMARY_SCHOOL,
        HighestEducation.JUNIOR_HIGH_SCHOOL,
        HighestEducation.TECHNICAL_SECONDARY_SCHOOL,
        HighestEducation.TECHNICAL_SCHOOL,
        HighestEducation.SENIOR_SCHOOL,
        HighestEducation.HIGHT_TECHNICAL_SCHOOL,
        HighestEducation.PROFESSIONAL_HIGH_SCHOOL,
        HighestEducation.FACHSCHULE,
        HighestEducation.HIGHER_VOCATIONAL,
        HighestEducation.JUNIOR_COLLEGE,
        HighestEducation.UNDERGRADUATE,
        HighestEducation.MASTER,
        HighestEducation.DOCTOR
    ];

    FUNDING_SOURCE: FundingSource[] = [FundingSource.SCHOLARSHIP, FundingSource.SELF_SUPPORTING, FundingSource.OTHER];

    HIGHEST_DEGREE: HighestDegree[] = [
        HighestDegree.NONE,
        HighestDegree.BACHELOR,
        HighestDegree.MASTER,
        HighestDegree.DOCTOR
    ];

    REGISTRATION_TYPE: RegistrationType[] = [RegistrationType.PERSONAL, RegistrationType.GROUP];

    ROLES: Roles[] = [Roles.ADMIN, Roles.ENROLLMENT_ADMIN, Roles.FINANCE, Roles.FACULTY, Roles.STUDENT];

    IDENTITY_CAS_PARAM_SERVICE = window.location.origin + "/identity-login";

    MARITAL_STATUS: MaritalType[] = [MaritalType.SINGLE, MaritalType.MARRIED];
}

export const $constants = new Constants();
